const topics = [
  { name: "#每日大赛新瓜", heat: "128万", trend: "hot" },
  { name: "#娱乐圈最新爆料", heat: "96万", trend: "up" },
  { name: "#榜单揭晓", heat: "87万", trend: "hot" },
  { name: "#黑料深扒", heat: "73万", trend: "up" },
  { name: "#擦边搞笑", heat: "68万", trend: "same" },
  { name: "#综艺翻车现场", heat: "59万", trend: "up" },
  { name: "#网红塌房记录", heat: "52万", trend: "new" },
  { name: "#直播名场面", heat: "47万", trend: "up" },
  { name: "#匿名爆料", heat: "41万", trend: "same" },
  { name: "#今日热搜", heat: "36万", trend: "new" },
  { name: "#吃瓜群众集合", heat: "32万", trend: "up" },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-10 text-center">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#about"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm cursor-pointer transition-all duration-200 whitespace-nowrap ${
                topic.trend === 'hot'
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : topic.trend === 'new'
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-200'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200'
              }`}
            >
              {topic.trend === 'hot' && (
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
              )}
              {topic.trend === 'new' && (
                <i className="ri-sparkling-line w-4 h-4 flex items-center justify-center text-accent-500"></i>
              )}
              {topic.trend === 'up' && (
                <i className="ri-arrow-up-line w-4 h-4 flex items-center justify-center text-secondary-600"></i>
              )}
              {topic.trend === 'same' && (
                <i className="ri-subtract-line w-4 h-4 flex items-center justify-center text-secondary-500"></i>
              )}
              <span>{topic.name}</span>
              <span className="text-xs opacity-60">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}